import React, {Component} from 'react';
import './Dialogs.min.css';
//import swoosh from'./swoosh.jpg';

class OptionHelpDialog extends Component {
    constructor(props) {
        super(props);
    }
    displayHelp(data, option){
        var title = data.parameters[option].title
        var help = [];
        help.push(<SystemPressureHelp title={title} />);
        help.push(<ModelNumberHelp title={title} />);
        help.push(<ForceRatingHelp title={title} />);
        help.push(<SystemThreadHelp title={title} />);
        help.push(<DisplacementTransducerHelp title={title} />);
        help.push(<DynamicStrokeHelp title={title} />);
        help.push(<ServoHelp title={title} />);
        help.push(<ServoHelp title={title} />);
        help.push(<ForceMeasurementHelp title={title} />);
        help.push(<RodBaseHelp title={title} />);
        help.push(<RodBaseHelp title={title} />);
        help.push(<HoistRestHelp title={title} />);
        return help[option];
    }
    render() {
        return (
            <div id="dlg_help_sysPressure" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Product Option Help</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        { this.displayHelp(this.props.data, this.props.option) }
                        <div id="dlg_quote_btn" className="dlg_btn" onClick={() => this.props.onClick(null)}>OK</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OptionHelpDialog;


class SystemPressureHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Maximum working pressure of your hydraulic system. Available in 21 MPa (3000 psi) and 28 MPa (4000 psi) configurations.
                Note:  Choice of system pressure may affect force rating for each specific model number below.</p>
            </div>
        );
    }
}

class ModelNumberHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>The chart below gives each model number, and their corresponding rod diameter and force rating for 21 MPa (3000 psi) and 28 MPa (4000 psi) configurations.</p>
                <p><b>Note:</b> The 201 Series actuators are single ended, meaning they have unequal working area. This results in a higher force rating in the compression (extension) cycle than the tension (retraction) cycle.</p>

                <table className="dlg_table flush-left" cellPadding="5">
                    <tbody>
                         <tr className="dlg_header_row">
                            <td colSpan="9" className="dlg_cell">21 MPa (3000 psi)</td>
                            <td colSpan="6" className="dlg_cell">28 MPa (4000 psi)</td>
                        </tr>
                        <tr className="dlg_subHeader_row">
                            <td colSpan="1" className="dlg_cell">Model Number</td>
                            <td colSpan="2" className="dlg_cell">Rod Diameter</td>
                            <td colSpan="2" className="dlg_cell">Bore</td>
                            <td colSpan="2" className="dlg_cell">Tension</td>
                            <td colSpan="2" className="dlg_cell">Compression</td>
                            <td colSpan="2" className="dlg_cell">Bore</td>
                            <td colSpan="2" className="dlg_cell">Tension</td>
                            <td colSpan="2" className="dlg_cell">Compression</td>
                        </tr>
                        <tr className="dlg_labels_row">
                            <td colSpan="1" className="dlg_cell"></td>
                            <td colSpan="1" className="dlg_cell">mm</td>
                            <td colSpan="1" className="dlg_cell">in</td>
                            <td colSpan="1" className="dlg_cell">mm</td>
                            <td colSpan="1" className="dlg_cell">in </td>
                            <td colSpan="1" className="dlg_cell">kN</td>
                            <td colSpan="1" className="dlg_cell">kip</td>
                            <td colSpan="1" className="dlg_cell">kN</td>
                            <td colSpan="1" className="dlg_cell">kip</td>
                            <td colSpan="1" className="dlg_cell">mm</td>
                            <td colSpan="1" className="dlg_cell">in</td>
                            <td colSpan="1" className="dlg_cell">kN</td>
                            <td colSpan="1" className="dlg_cell">kip</td>
                            <td colSpan="1" className="dlg_cell">kN</td>
                            <td colSpan="1" className="dlg_cell">kip</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.1</td>
                            <td colSpan="1" className="dlg_cell">25.4</td>
                            <td colSpan="1" className="dlg_cell">1</td>
                            <td colSpan="1" className="dlg_cell">34.9</td>
                            <td colSpan="1" className="dlg_cell">1.38</td>
                            <td colSpan="1" className="dlg_cell">9</td>
                            <td colSpan="1" className="dlg_cell">2</td>
                            <td colSpan="1" className="dlg_cell">19</td>
                            <td colSpan="1" className="dlg_cell">4</td>
                            <td colSpan="1" className="dlg_cell">31.8</td>
                            <td colSpan="1" className="dlg_cell">1.25</td>
                            <td colSpan="1" className="dlg_cell">7.7</td>
                            <td colSpan="1" className="dlg_cell">2</td>
                            <td colSpan="1" className="dlg_cell">21</td>
                            <td colSpan="1" className="dlg_cell">5</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.11</td>
                            <td colSpan="1" className="dlg_cell">34.9</td>
                            <td colSpan="1" className="dlg_cell">1.38</td>
                            <td colSpan="1" className="dlg_cell">47.6</td>
                            <td colSpan="1" className="dlg_cell">1.88</td>
                            <td colSpan="1" className="dlg_cell">16</td>
                            <td colSpan="1" className="dlg_cell">4</td>
                            <td colSpan="1" className="dlg_cell">36</td>
                            <td colSpan="1" className="dlg_cell">8</td>
                            <td colSpan="1" className="dlg_cell">44.5</td>
                            <td colSpan="1" className="dlg_cell">1.75</td>
                            <td colSpan="1" className="dlg_cell">16</td>
                            <td colSpan="1" className="dlg_cell">4</td>
                            <td colSpan="1" className="dlg_cell">42</td>
                            <td colSpan="1" className="dlg_cell">9</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.17</td>
                            <td colSpan="1" className="dlg_cell">44.5</td>
                            <td colSpan="1" className="dlg_cell">1.75</td>
                            <td colSpan="1" className="dlg_cell">63.5</td>
                            <td colSpan="1" className="dlg_cell">2.5</td>
                            <td colSpan="1" className="dlg_cell">32</td>
                            <td colSpan="1" className="dlg_cell">7</td>
                            <td colSpan="1" className="dlg_cell">63</td>
                            <td colSpan="1" className="dlg_cell">14</td>
                            <td colSpan="1" className="dlg_cell">57.2</td>
                            <td colSpan="1" className="dlg_cell">2.25</td>
                            <td colSpan="1" className="dlg_cell">27</td>
                            <td colSpan="1" className="dlg_cell">6</td>
                            <td colSpan="1" className="dlg_cell">69</td>
                            <td colSpan="1" className="dlg_cell">16</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.2</td>
                            <td colSpan="1" className="dlg_cell">50.8</td>
                            <td colSpan="1" className="dlg_cell">2</td>
                            <td colSpan="1" className="dlg_cell">82.6</td>
                            <td colSpan="1" className="dlg_cell">3.25</td>
                            <td colSpan="1" className="dlg_cell">66</td>
                            <td colSpan="1" className="dlg_cell">15</td>
                            <td colSpan="1" className="dlg_cell">107</td>
                            <td colSpan="1" className="dlg_cell">24</td>
                            <td colSpan="1" className="dlg_cell">76.2</td>
                            <td colSpan="1" className="dlg_cell">3</td>
                            <td colSpan="1" className="dlg_cell">68</td>
                            <td colSpan="1" className="dlg_cell">15</td>
                            <td colSpan="1" className="dlg_cell">123</td>
                            <td colSpan="1" className="dlg_cell">28</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.25</td>
                            <td colSpan="1" className="dlg_cell">63.5</td>
                            <td colSpan="1" className="dlg_cell">2.5</td>
                            <td colSpan="1" className="dlg_cell">101.6</td>
                            <td colSpan="1" className="dlg_cell">4</td>
                            <td colSpan="1" className="dlg_cell">99</td>
                            <td colSpan="1" className="dlg_cell">22</td>
                            <td colSpan="1" className="dlg_cell">162</td>
                            <td colSpan="1" className="dlg_cell">36</td>
                            <td colSpan="1" className="dlg_cell">95.3</td>
                            <td colSpan="1" className="dlg_cell">3.75</td>
                            <td colSpan="1" className="dlg_cell">106</td>
                            <td colSpan="1" className="dlg_cell">24</td>
                            <td colSpan="1" className="dlg_cell">192</td>
                            <td colSpan="1" className="dlg_cell">43</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.3</td>
                            <td colSpan="1"  className="dlg_cell">76.2</td>
                            <td colSpan="1"  className="dlg_cell">3</td>
                            <td colSpan="1"  className="dlg_cell">127</td>
                            <td colSpan="1"  className="dlg_cell">5</td>
                            <td colSpan="1" className="dlg_cell">162</td>
                            <td colSpan="1" className="dlg_cell">36</td>
                            <td colSpan="1" className="dlg_cell">253</td>
                            <td colSpan="1" className="dlg_cell">57</td>
                            <td colSpan="1" className="dlg_cell">114.3</td>
                            <td colSpan="1" className="dlg_cell">4.5</td>
                            <td colSpan="1" className="dlg_cell">153</td>
                            <td colSpan="1" className="dlg_cell">34</td>
                            <td colSpan="1" className="dlg_cell">276</td>
                            <td colSpan="1" className="dlg_cell">62</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.35</td>
                            <td colSpan="1" className="dlg_cell">88.9</td>
                            <td colSpan="1" className="dlg_cell">3.5</td>
                            <td colSpan="1" className="dlg_cell">152.4</td>
                            <td colSpan="1" className="dlg_cell">6</td>
                            <td colSpan="1" className="dlg_cell">241</td>
                            <td colSpan="1" className="dlg_cell">54</td>
                            <td colSpan="1" className="dlg_cell">365</td>
                            <td colSpan="1" className="dlg_cell">82</td>
                            <td colSpan="1" className="dlg_cell">139.7</td>
                            <td colSpan="1" className="dlg_cell">5.5</td>
                            <td colSpan="1" className="dlg_cell">245</td>
                            <td colSpan="1" className="dlg_cell">55</td>
                            <td colSpan="1" className="dlg_cell">412</td>
                            <td colSpan="1" className="dlg_cell">93</td>
                        </tr>
                         <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.4</td>
                            <td colSpan="1" className="dlg_cell">101.6</td>
                            <td colSpan="1" className="dlg_cell">4</td>
                            <td colSpan="1" className="dlg_cell">177.8</td>
                            <td colSpan="1" className="dlg_cell">7</td>
                            <td colSpan="1" className="dlg_cell">334</td>
                            <td colSpan="1" className="dlg_cell">75</td>
                            <td colSpan="1" className="dlg_cell">496</td>
                            <td colSpan="1" className="dlg_cell">112</td>
                            <td colSpan="1" className="dlg_cell">165.1</td>
                            <td colSpan="1" className="dlg_cell">6.5</td>
                            <td colSpan="1" className="dlg_cell">358</td>
                            <td colSpan="1" className="dlg_cell">80</td>
                            <td colSpan="1" className="dlg_cell">576</td>
                            <td colSpan="1" className="dlg_cell">129</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.45</td>
                            <td colSpan="1" className="dlg_cell">114.3</td>
                            <td colSpan="1" className="dlg_cell">4.5</td>
                            <td colSpan="1" className="dlg_cell">203.2</td>
                            <td colSpan="1" className="dlg_cell">8</td>
                            <td colSpan="1" className="dlg_cell">443</td>
                            <td colSpan="1" className="dlg_cell">100</td>
                            <td colSpan="1" className="dlg_cell">648</td>
                            <td colSpan="1" className="dlg_cell">146</td>
                            <td colSpan="1" className="dlg_cell">184.2</td>
                            <td colSpan="1" className="dlg_cell">7.25</td>
                            <td colSpan="1" className="dlg_cell">440</td>
                            <td colSpan="1" className="dlg_cell">99</td>
                            <td colSpan="1" className="dlg_cell">716</td>
                            <td colSpan="1" className="dlg_cell">161</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.5</td>
                            <td colSpan="1" className="dlg_cell">127</td>
                            <td colSpan="1" className="dlg_cell">5</td>
                            <td colSpan="1" className="dlg_cell">222.3</td>
                            <td colSpan="1" className="dlg_cell">8.75</td>
                            <td colSpan="1" className="dlg_cell">522</td>
                            <td colSpan="1" className="dlg_cell">117</td>
                            <td colSpan="1" className="dlg_cell">776</td>
                            <td colSpan="1" className="dlg_cell">174</td>
                            <td colSpan="1" className="dlg_cell">203.2</td>
                            <td colSpan="1" className="dlg_cell">8</td>
                            <td colSpan="1" className="dlg_cell">531</td>
                            <td colSpan="1" className="dlg_cell">119</td>
                            <td colSpan="1" className="dlg_cell">872</td>
                            <td colSpan="1" className="dlg_cell">196</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.6</td>
                            <td colSpan="1" className="dlg_cell">152.4</td>
                            <td colSpan="1" className="dlg_cell">6</td>
                            <td colSpan="1" className="dlg_cell">254</td>
                            <td colSpan="1" className="dlg_cell">10</td>
                            <td colSpan="1" className="dlg_cell">648</td>
                            <td colSpan="1" className="dlg_cell">146</td>
                            <td colSpan="1" className="dlg_cell">1013</td>
                            <td colSpan="1" className="dlg_cell">228</td>
                            <td colSpan="1" className="dlg_cell">228.6</td>
                            <td colSpan="1" className="dlg_cell">9</td>
                            <td colSpan="1" className="dlg_cell">613</td>
                            <td colSpan="1" className="dlg_cell">138</td>
                            <td colSpan="1" className="dlg_cell">1104</td>
                            <td colSpan="1" className="dlg_cell">248</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.7</td>
                            <td colSpan="1" className="dlg_cell">177.8</td>
                            <td colSpan="1" className="dlg_cell">7</td>
                            <td colSpan="1" className="dlg_cell">304.8</td>
                            <td colSpan="1" className="dlg_cell">12</td>
                            <td colSpan="1" className="dlg_cell">962</td>
                            <td colSpan="1" className="dlg_cell">200</td>
                            <td colSpan="1" className="dlg_cell">1459</td>
                            <td colSpan="1" className="dlg_cell">328</td>
                            <td colSpan="1" className="dlg_cell">279.4</td>
                            <td colSpan="1" className="dlg_cell">11</td>
                            <td colSpan="1" className="dlg_cell">981</td>
                            <td colSpan="1" className="dlg_cell">221</td>
                            <td colSpan="1" className="dlg_cell">1649</td>
                            <td colSpan="1" className="dlg_cell">371</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.8</td>
                            <td colSpan="1" className="dlg_cell">203.2</td>
                            <td colSpan="1" className="dlg_cell">8</td>
                            <td colSpan="1" className="dlg_cell">355.6</td>
                            <td colSpan="1" className="dlg_cell">14</td>
                            <td colSpan="1" className="dlg_cell">1337</td>
                            <td colSpan="1" className="dlg_cell">301</td>
                            <td colSpan="1" className="dlg_cell">1986</td>
                            <td colSpan="1" className="dlg_cell">446</td>
                            <td colSpan="1" className="dlg_cell">323.9</td>
                            <td colSpan="1" className="dlg_cell">12.75</td>
                            <td colSpan="1" className="dlg_cell">1343</td>
                            <td colSpan="1" className="dlg_cell">302</td>
                            <td colSpan="1" className="dlg_cell">2215</td>
                            <td colSpan="1" className="dlg_cell">498</td>
                        </tr>
                        <tr className="dlg_row">
                            <td colSpan="1" className="dlg_cell">201.9</td>
                            <td colSpan="1" className="dlg_cell">228.6</td>
                            <td colSpan="1" className="dlg_cell">9</td>
                            <td colSpan="1" className="dlg_cell">406.4</td>
                            <td colSpan="1" className="dlg_cell">16</td>
                            <td colSpan="1" className="dlg_cell">1773</td>
                            <td colSpan="1" className="dlg_cell">399</td>
                            <td colSpan="1" className="dlg_cell">2594</td>
                            <td colSpan="1" className="dlg_cell">583</td>
                            <td colSpan="1" className="dlg_cell">368.3</td>
                            <td colSpan="1" className="dlg_cell">14.5</td>
                            <td colSpan="1" className="dlg_cell">1761</td>
                            <td colSpan="1" className="dlg_cell">396</td>
                            <td colSpan="1" className="dlg_cell">2865</td>
                            <td colSpan="1" className="dlg_cell">644</td>
                        </tr>
                    </tbody>
                </table>

                <p>All 201, 242, and 244 actuators are fatigue-rated to their full force rating.
                This rating, however, was established assuming minimal overhead for rod friction and losses due to backpressure check valves on HDMs, HSMs and HPUs. General recommendations for actuator sizing would be as follows:</p>
                <ul>
                    <li>For static applications, recommended force requirement should be below 95% of the force rating, to ensure that loads can be met even with some actuator friction and system losses.</li>
                    <li>For dynamic applications, recommend force requirement should be below 80% of the force rating, to ensure that loads can be met dynamically with appropriate servovalve sizing.</li>
                </ul>
            </div>
        );
    }
}

class ForceRatingHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Force Rating is listed here for your informational benefit.  This field is populated based on the selection made above in the “SYSTEM THREAD TYPE” and “MODEL NUMBER” fields.</p>
            </div>
        );
    }
}

class SystemThreadHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>System Thread Type allows you to select between either Metric or US Customary.</p>
            </div>
        );
    }
}

class DisplacementTransducerHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>Series 201 actuators provide three following selections:</p>
                <ol>
                    <li>TEMPOSONIC G <b>(Temposonic G Included)</b> - This selects the Temposonic compatible with MTS 494 / 493 Controllers using a +/-10VDC excitation and +/-5VDC analog output.</li>
                    <li>TEMPOSONIC READY <b>(Temposonic Not Included)</b> – This selection excludes the Temposonic Transducer from the configuration while still providing a 201 with the Piston Rod and End Cap provisions to add a Temposonic at a later date.</li>
                    <li>NON-TRANSDUCER <b>(No transducer options possible – solid rod)</b> – This is the most compact and economical option available. This also prohibits the ability to add an internally mounted displacement transducer at a later date.</li>
                </ol>
                <div className="dlg_sideByside_images">
                        <div className="dlg_row">
                            <div className="dlg_cell"><img className="small" src="images/non-transducer.jpg" /><div className="dlg_cell dlg_cell_text">Tempsonic Installed</div></div>
                            <div className="dlg_cell "><img className="small" src="images/temposonic_installed.jpg" /><div className="dlg_cell dlg_cell_text">Non-Transducer</div></div>
                        </div>
                </div>
            </div>
        );
    }
}

class DynamicStrokeHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>For standard 201 actuators, the stroke is the maximum usable piston rod travel. For custom 201 actuators with hydraulic cushions, the usable stroke is reduced by 25.4 mm (1.00 in).</p>
                <img className="medium" src="images/stroke.jpg" />
            </div>
        );
    }
}

class ServoHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p>The maximum piston velocity permitted for a given Model Number constrains the maximum size Servovalve that can be mounted. The selected Model Number also determines whether you can add a 2nd Servovalve for an increased flow capacity.</p>
            </div>
        );
    }
}

class ForceMeasurementHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>Delta P Cell:</b></u>  Offered as an economical alternative to a load cell 1000 kN (220 kip) and higher. Transducer is high precision and fatigue rated. Area ratio matched to minimize zero shift and thermal effects. This measurement technique does not exclude seal and bearing friction. Consider this option if a high accuracy force reading is not required for your application. Most appropriate for applications utilizing more than 50% of actuator rated capacity.</p>
                <p><u><b>Load Cell</b></u> - Single Bridge - Fatigue Sized:  Standard load cell size, sufficient to handle all actuator use cases without a fatigue failure. Can be calibrated out to 150% of force rating if necessary. </p>
                <p><u><b>Load Cell</b></u> - Single Bridge - Compression Sized:  Load cell is larger than necessary for fatigue. Typically is not required, contact MTS Sales for more information.</p>
                <p><u><b>Dual Bridge:</b></u>   Used in applications where redundancy of the load measurement is required.</p>
            </div>
        );
    }
}

class RodBaseHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>

                <span className="dlg_h1">Type</span>
                <p><u><b>Adjustable Swivel:</b></u>  Offered as a high-performance option for dynamic applications. The adjustable swivel includes backlash adjustment to enable continuous close pe mvmkvfit bearing tolerance, minimizing bearing backlash for optimal testing speed and accuracy. </p>
                <p><u><b>Non-Adjustable Swivel:</b></u>  Offered as an economical option if the actuator will be used in static or pseudo-dynamic applications.</p>

                <div className="dlg_sideByside_images">
                    <div className="dlg_row">
                        <div className="dlg_cell"><img className="small" src="images/adjustable_swivel.jpg" /><div className="dlg_cell dlg_cell_text">Adjustable Swivel</div></div>
                        <div className="dlg_cell "><img className="small" src="images/non_adjustable_swivel.jpg" /><div className="dlg_cell dlg_cell_text">Non-Adjustable Swivel</div></div>
                    </div>
                </div>
                <span className="dlg_h1">Sizing</span>
                <p><u><b>Static Sized:</b></u>  Swivel is of sufficient size to handle all actuator use cases without a static failure. Consider this option if actuator will be used in static applications at or below tension rating. Not recommended or guaranteed for applications exceeding 10,000 cycles at maximum actuator capability.</p>
                <p><u><b>Fatigue Sized:</b></u>  Standard swivel size, sufficient to handle all actuator use cases without a fatigue failure.</p>
                <p><u><b>Compression Sized:</b></u>  Swivel is larger than necessary for fatigue. Typically is not required, contact MTS Sales for more information.</p>
            </div>
        );
    }
}


class HoistRestHelp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="dlg_prod_help">
                <span className="dlg_title_txt">{this.props.title}</span>
                <p><u><b>Hoist Rings:</b></u> Swiveling and CE-Rated lifting device.</p>
                <p><u><b>Rest Pads:</b></u> High durometer urethane pads for protection of actuator finish while in storage or transit.</p>
                <img className="medium" src="images/hoist_ring_rest_pad.jpg" />
            </div>
        );
    }
}
